import { SingleLayoutContainerProps } from '../single-layout-container.model';
import { ViewLayoutController } from './view.controller';

export const ViewLayout = (props: SingleLayoutContainerProps): JSX.Element => {
  return <ViewLayoutController {...props} />;
};
